import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from './token.service';

import { ROUTES } from '../constants'

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService  {
  constructor(
    public tokenService: TokenService,
    public _router: Router
  ) {}

  canActivate() {
    console.log('[canActivate] Applying guard...')
    if (this.tokenService.getToken() !== undefined && this.tokenService.getToken() !== '' && this.tokenService.getToken() !== null) {
      return true;
    } else {
      console.warn(`[canActivate] Login detection... fail!`);
      this._router.navigate([ROUTES.LOGIN]);
      return false;
    }
  }
}
